export default __webpack_public_path__ + "static/media/emptyBetslip.5606fa08.svg";